import React from 'react';

export const BuildhubLogo: React.FC = () => (
  <div style={{ height: '180px', display: 'flex', alignItems: 'center' }}>
    <img
      src="/images/logos/buildhub-logo.webp"
      alt="Buildhub"
      className="dark:hidden"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
      fetchPriority="high"
    />
    <img
      src="/images/logos/buildhub-logo-dark.webp"
      alt="Buildhub"
      className="hidden dark:block"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
      fetchPriority="high"
    />
  </div>
);
